/* @flow */

import { type Pedido } from './types';

export const total = (pedido: Pedido) => (
    pedido.valor - (pedido.valorVoucher || 0) + (pedido.taxaEntrega || 0)
);

export const troco = (pedido: Pedido) => {
    if (pedido.troco) {
        return Math.abs((pedido.troco || 0) - total(pedido));
    }
    return 0;
};
